/**
 * Base endpoints
 * @see https://redux-toolkit.js.org/rtk-query/usage/code-splitting for more information
 */

import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';

const apiAxios = axios.create({
  withCredentials: true,
  headers: {
    'Content-type': 'application/json',
  },
});

// see https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#axios-basequery
export const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: '' }
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig['method'];
      data?: AxiosRequestConfig['data'];
      params?: AxiosRequestConfig['params'];
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params }) => {
    try {
      const result = await apiAxios({ url: baseUrl + url, method, data, params });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

// const apiServiceUrl = `${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/`;
export const apiServiceUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/`;
export const backendApiServiceUrl = `${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/`;

// if this cast to `CreateApiOptions`, TypeScript fails because it
// reduces fields such as `reducerPath` down from a type literal to a `string`.
// i.e. reducerPath goes from `'apiService'` to `string`
// TODO is there a way to type check these defaults?
export const createApiDefaults = {
  reducerPath: 'apiService',
  baseQuery: axiosBaseQuery({ baseUrl: apiServiceUrl }),
  refetchOnReconnect: true,
  // refetchOnFocus: true, // commenting this a its causing rendering all places + PPP-575
  // refetchOnMountOrArgChange: 300, // in seconds
};

/** Wrapper around {@link createApi} with customized defaults
 *
 * RTK Query doesn't have a good way to override these each time you call
 * `injectEndpoints`, so we have this helper function
 *
 * @see {@link createApi}
 * @param reducerPath Path where the data will be stored under Redux
 */
// export const createQwaApi: typeof createApi<AxiosBaseQueryType, ? extends EndpointDefinitions, ReducerPath extends string = 'api', TagTypes extends string = never> = (options: Optional<Parameters<CreateApiType>[0], 'baseQuery'>) => {
//   const finalOptions = { ...createApiDefaults, ...options } as typeof options;

//   return createApi(finalOptions);
// } as CreateApiType<>;
